import React, { useEffect, useState } from 'react';
import { App, Button, Select, Space, Spin, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/es/table';
import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../../../core/redux';
import { initialEditableTable, tablesSlice } from '../../TablesSlice';
import { useNavigate } from 'react-router-dom';
import { localStorage, routes } from '../../../../../types/types';
import { PageHeader } from '../../../../common/components/PageHeader/PageHeader';
import { Filters } from './Filters/Filters';
import { DataType } from '../../interfaces/interfaces';
import { projectsApiService } from '../../../../api/projects/projectsApiService';
import { notificationMessages, showNotification } from '../../../usersPage/helpers/helpers';
import { getInsensitiveTextSearch, getStatus, getUrlParams } from '../../helpers/helpers';
import StorageService from '../../../../common/helpers/storageService/storage-service';
import { getErrors, getInitData } from '../../../../helpers/helpers';
import { authorizationSlice } from '../../../authorization/AuthorizationSlice';
import { DeleteOutlined } from '@ant-design/icons';
import { ConfirmDelete } from '../../../../common/components/ConfirmDelete/ConfirmDelete';

import s from './TableAllProjects.module.scss';
interface IChangeStatus {
  project_name: string;
  description: string;
  mart_code: string;
  docs_id: Array<number>;
  status: number;
  is_ready_to_test: boolean;
  claim_is_created: boolean;
}
const getColumns = (
  redirectToRedactor: (key: string) => void,
  handleChangeStatus: (key: IChangeStatus, id: number) => void,
  handleDeleteProject: (id: number) => void,
  size: string,
) => {
  const dateWidth = size === 'large' ? 150 : 100;
  const docWidth = size === 'large' ? 120 : 80;
  const mailWidth = size === 'large' ? 140 : 100;
  const columns: ColumnsType<DataType> = [
    {
      title: 'Название',
      dataIndex: 'project_name',
      key: 'project_name',
      // ellipsis: true,
      // width: 250,
      render: (text, { key }) => {
        return (
          <div className={s.nameCol}>
            {text ? (
              <Tooltip placement='top' title={text}>
                <Button
                  className={s.projectLabel}
                  type={'link'}
                  onClick={() => redirectToRedactor(key)}
                >
                  {text}
                </Button>
              </Tooltip>
            ) : (
              '-'
            )}
          </div>
        );
      },
    },
    {
      title: 'Описание',
      dataIndex: 'description',
      key: 'description',
      ellipsis: true,
      render: (text) => (
        <div className={s.descriptionCol}>
          {text ? (
            <Tooltip placement='top' title={text} autoAdjustOverflow={true}>
              <p className={s.textSlice}>{text}</p>
            </Tooltip>
          ) : (
            '-'
          )}
        </div>
      ),
    },
    {
      title: 'Документы',
      dataIndex: 'doc_type',
      key: 'doc_type',
      width: docWidth,
      render: (_, { doc_type }) => {
        const docKeys = doc_type.map(({ code }) => code).join(', ');
        const docTitles = doc_type.map(({ display }) => display).join(', ');
        return (
          <>
            {doc_type?.length ? (
              <div>
                <Tooltip placement='top' title={docTitles} autoAdjustOverflow={true}>
                  {docKeys}
                </Tooltip>
              </div>
            ) : (
              '-'
            )}
          </>
        );
      },
    },
    {
      title: 'Дата создания',
      key: 'created_at',
      dataIndex: 'created_at',
      // className: 'tdDate',
      width: dateWidth,
      render: (_, { created_at }) => {
        return (
          <div className={s.created_at}>
            {created_at && moment(created_at).isValid()
              ? moment(created_at, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
              : '-'}
          </div>
        );
      },
      sorter: (a: DataType, b: DataType) => {
        const timeStampA = moment(a.created_at, 'YYYY-MM-DDTHH:mm:ss').unix();
        const timeStampB = moment(b.created_at, 'YYYY-MM-DDTHH:mm:ss').unix();

        return timeStampB - timeStampA;
      },
    },
    {
      title: 'Автор создания',
      key: 'author',
      dataIndex: 'author',
      width: mailWidth,
      render: (_, { author }) => <>{author || '-'}</>,
    },
    {
      title: 'Дата изменения',
      key: 'updated_at',
      dataIndex: 'updated_at',
      // className: 'tdDate',
      width: dateWidth,
      render: (_, { updated_at }) => {
        return (
          <div className={s.created_at}>
            {updated_at && moment(updated_at).isValid()
              ? moment(updated_at, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
              : '-'}
          </div>
        );
      },
      sorter: (a: DataType, b: DataType) => {
        const timeStampA = moment(a.updated_at, 'YYYY-MM-DDTHH:mm:ss').unix();
        const timeStampB = moment(b.updated_at, 'YYYY-MM-DDTHH:mm:ss').unix();

        return timeStampB - timeStampA;
      },
    },
    {
      title: 'Автор изменений',
      key: 'author_changes',
      dataIndex: 'author_changes',
      width: mailWidth,
      render: (_, { author_changes }) => <>{author_changes || '-'}</>,
    },
    {
      title: 'Статус',
      key: 'status',
      dataIndex: 'status',
      width: 120,
      render: (_, record) => {
        const handleChange = (val) => {
          const docs: Array<number> = record?.doc_type?.length
            ? record?.doc_type.map(({ id }) => id)
            : [];
          const value = {
            project_name: record.project_name,
            description: record.description,
            mart_code: record.mart_code,
            docs_id: docs,
            status: val,
            is_ready_to_test: record.is_ready_to_test,
            claim_is_created: record.claim_is_created,
          };
          handleChangeStatus(value, record.id);
        };
        return (
          <Space style={{ overflow: 'hidden' }} size='middle'>
            <Select
              // suffixIcon={<div className={s.statusWrapper}>{getStatus(status)}</div>}
              defaultValue={record.status}
              bordered={false}
              style={{ width: 120 }}
              onChange={handleChange}
              options={[
                {
                  value: 1,
                  label: <div className={s.statusWrapper}>{getStatus(1)}</div>,
                },
                { value: 2, label: <div className={s.statusWrapper}>{getStatus(2)}</div> },
                { value: 3, label: <div className={s.statusWrapper}>{getStatus(3)}</div> },
              ]}
            />
          </Space>
        );
      },
    },
    {
      title: 'Удалить',
      key: 'actions',
      dataIndex: 'actions',
      width: 70,
      render: (_, record) => {
        return (
          <div
            className={'deleteBtn'}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <ConfirmDelete
              placement={'topLeft'}
              handleDelete={() => handleDeleteProject(record.id)}
              title={'Удалить проект?'}
              description={' '}
            >
              <Button
                size={'small'}
                type='primary'
                shape='circle'
                danger
                icon={<DeleteOutlined />}
                className={'deleteBtn'}
                // onClick={handleDeleteProject}
              ></Button>
            </ConfirmDelete>
          </div>
        );
      },
    },
  ];
  return columns;
};

const { setEditableTable, setSearchXPathVal } = tablesSlice.actions;
const { setIsAuth } = authorizationSlice.actions;

export const TableAllProjects = () => {
  const { notification } = App.useApp();

  const [
    getAllProjects,
    {
      data: projectsData,
      isError: projectsIsError,
      error: projectsError,
      status: projectsStatus,
      isLoading: projectsLoading,
    },
  ] = projectsApiService.useGetProjectsMutation();

  const [
    editProject,
    {
      data: editProjectData,
      error: editProjectError,
      isLoading: editProjectLoading,
      // status: editProjectStatus,
    },
  ] = projectsApiService.useEditNewProjectMutation();
  const [
    deleteProject,
    {
      data: deleteProjectData,
      error: deleteProjectError,
      isLoading: deleteProjectLoading,
      // status: editProjectStatus,
    },
  ] = projectsApiService.useDeleteProjectMutation();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [data, setProjectData] = useState(getInitData(projectsData));
  const [searched, setSearched] = useState('');
  const [active, setActive] = useState('Active, Draft');

  const { size } = useAppSelector((state) => state.appReducer);
  const handleSearch = (searched: string) => {
    setSearched(searched);
  };

  const handleChangeStatus = (value, id) => {
    editProject({ data: value, id });
  };

  const handleDeleteProject = (key) => {
    if (key) {
      deleteProject({ id: key });
    }
  };
  const redirectToRedactor = (editableTableKey) => {
    const editableTable = editableTableKey && data.find(({ key }) => key === editableTableKey);
    dispatch(setEditableTable(editableTable || initialEditableTable));

    navigate(routes.documentProcessing);
  };

  const statusFilteredData = (data || []).filter((item) => active.includes(item.statuses.status));
  const filteredData = searched
    ? (statusFilteredData || []).filter((item) =>
        getInsensitiveTextSearch(item.project_name, searched),
      )
    : statusFilteredData;

  const { projectsErrorData, editProjError, editProjectsErrorData, deleteProjectErrorData } =
    getErrors({
      projectsError,
      editProjectError,
      editProjectData,
      deleteProjectError,
    });
  useEffect(() => {
    getAllProjects({ skip: 0, limit: 1000 });
  }, []);

  const { params } = getUrlParams(window.location.href);

  useEffect(() => {
    if (Object.keys(params).length && params.editableTableKey && data.length) {
      redirectToRedactor(Number(params.editableTableKey));
      dispatch(setSearchXPathVal(params.code));
    }
  }, [params, data]);
  useEffect(() => {
    if (projectsErrorData === 'Unauthorized') {
      StorageService.set(localStorage.token, false);
      dispatch(setIsAuth(false));
    }
    if (projectsIsError && projectsStatus === 'rejected' && !projectsLoading) {
      showNotification(
        notification,
        projectsErrorData || ' ',
        notificationMessages.errGetProjects,
        'error',
      );
    }
  }, [projectsStatus, projectsIsError, projectsLoading]);

  useEffect(() => {
    if (!projectsIsError && !projectsLoading && projectsStatus === 'fulfilled' && projectsData) {
      setProjectData(getInitData(projectsData || []));
    }
  }, [projectsLoading, projectsStatus, projectsIsError, projectsData]);

  useEffect(() => {
    if (editProjectsErrorData === 'Unauthorized') {
      StorageService.set(localStorage.token, false);
      dispatch(setIsAuth(false));
    }
    if (!editProjectError && !editProjectLoading && editProjectData) {
      getAllProjects({ skip: 0, limit: 1000 });
    }
    if (editProjectError && !editProjectLoading && !editProjectData) {
      showNotification(
        notification,
        editProjError || ' ',
        notificationMessages.errGetProjects,
        'error',
      );
    }
  }, [editProjectError, editProjectLoading, editProjectData]);
  useEffect(() => {
    if (!deleteProjectError && !deleteProjectLoading && deleteProjectData) {
      getAllProjects({ skip: 0, limit: 1000 });
    }
    if (deleteProjectError && !deleteProjectLoading && !deleteProjectData) {
      showNotification(
        notification,
        deleteProjectErrorData || ' ',
        notificationMessages.deleteProjectError,
        'error',
      );
    }
  }, [deleteProjectError, deleteProjectLoading, deleteProjectData]);
  return (
    <div className={s.TableAllProjects}>
      <Spin tip='Loading...' spinning={projectsLoading} size='large'>
        <PageHeader breadcrumb={[]} title={'Все проекты'} />

        <Filters
          handleSearch={handleSearch}
          setActive={setActive}
          redirectToRedactor={redirectToRedactor}
        />
        <Table
          className={s.tableAllProjects}
          columns={getColumns(redirectToRedactor, handleChangeStatus, handleDeleteProject, size)}
          dataSource={filteredData}
          pagination={{
            locale: {
              items_per_page: '/ на странице',
            },
            defaultPageSize: 10,
            showSizeChanger: true,
            total: filteredData.length,
            showTotal: (total, range) => `${range.join(' - ')} из ${total} проектов`,
          }}
          size={'middle'}
        />
      </Spin>
    </div>
  );
};
